module.exports = __webpack_public_path__ + "static/img/pic_success.9b331b73.png";